import { createContext } from 'react';
import { ISupervisionProjectContext } from '../interfaces/supervision-project.interface';

export const SupervisionProjectContext = createContext({} as ISupervisionProjectContext);
